import React from 'react';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import {
  CHILDREN_PROPTYPES,
  ALIGNMENT_PROPTYPES
} from 'base/constants/propTypes';
import { CENTER } from 'base/constants/alignment';

const HeadingThree = ({ children, desktopAlign }) => {
  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));
  const processedAlignment = isMediumAndUp ? desktopAlign : 'left';
  return (
    <Typography variant="h3" align={processedAlignment}>
      {children}
    </Typography>
  );
};

HeadingThree.defaultProps = {
  desktopAlign: CENTER
};
HeadingThree.propTypes = {
  children: CHILDREN_PROPTYPES.isRequired,
  desktopAlign: ALIGNMENT_PROPTYPES
};

export default HeadingThree;
